import { getFirestore, collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import app from '../firebase';

const db = getFirestore(app);

// Categorías
export const getCategories = async () => {
  try {
    const categoriesCol = collection(db, 'categories');
    const snapshot = await getDocs(categoriesCol);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting categories:', error);
    return [];
  }
};

export const addCategory = async (categoryData) => {
  try {
    const categoriesCol = collection(db, 'categories');
    const docRef = await addDoc(categoriesCol, categoryData);
    return { id: docRef.id, ...categoryData };
  } catch (error) {
    console.error('Error adding category:', error);
    throw error;
  }
};

export const updateCategory = async (id, categoryData) => {
  try {
    const categoryDoc = doc(db, 'categories', id);
    await updateDoc(categoryDoc, categoryData);
    return { id, ...categoryData };
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
    const categoryDoc = doc(db, 'categories', id);
    await deleteDoc(categoryDoc);
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

// Productos
export const getProducts = async (categoryFilter = null, includeInactive = false) => {
  try {
    const productsCol = collection(db, 'products');
    const snapshot = await getDocs(productsCol);
    let products = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
    if (categoryFilter) {
      products = products.filter(p => p.category === categoryFilter);
    }
    
    if (!includeInactive) {
      products = products.filter(p => p.isActive !== false);
    }
    
    return products;
  } catch (error) {
    console.error('Error getting products:', error);
    return [];
  }
};

export const addProduct = async (productData) => {
  try {
    const productsCol = collection(db, 'products');
    const docRef = await addDoc(productsCol, productData);
    return { id: docRef.id, ...productData };
  } catch (error) {
    console.error('Error adding product:', error);
    throw error;
  }
};

export const updateProduct = async (id, productData) => {
  try {
    const productDoc = doc(db, 'products', id);
    await updateDoc(productDoc, productData);
    return { id, ...productData };
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};

export const deleteProduct = async (id) => {
  try {
    const productDoc = doc(db, 'products', id);
    await deleteDoc(productDoc);
  } catch (error) {
    console.error('Error deleting product:', error);
    throw error;
  }
};

// Reservaciones/Compras
export const getReservations = async () => {
  try {
    const reservationsCol = collection(db, 'reservations');
    const q = query(reservationsCol, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting reservations:', error);
    return [];
  }
};

export const addReservation = async (reservationData) => {
  try {
    const reservationsCol = collection(db, 'reservations');
    const docRef = await addDoc(reservationsCol, reservationData);
    return { id: docRef.id, ...reservationData };
  } catch (error) {
    console.error('Error adding reservation:', error);
    throw error;
  }
};

// Logos
export const getLogos = async () => {
  try {
    const logosCol = collection(db, 'logos');
    const q = query(logosCol, orderBy('order', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting logos:', error);
    return [];
  }
};

export const addLogo = async (logoData) => {
  try {
    const logosCol = collection(db, 'logos');
    const docRef = await addDoc(logosCol, logoData);
    return { id: docRef.id, ...logoData };
  } catch (error) {
    console.error('Error adding logo:', error);
    throw error;
  }
};

export const updateLogo = async (id, logoData) => {
  try {
    const logoDoc = doc(db, 'logos', id);
    await updateDoc(logoDoc, logoData);
    return { id, ...logoData };
  } catch (error) {
    console.error('Error updating logo:', error);
    throw error;
  }
};

export const deleteLogo = async (id) => {
  try {
    const logoDoc = doc(db, 'logos', id);
    await deleteDoc(logoDoc);
  } catch (error) {
    console.error('Error deleting logo:', error);
    throw error;
  }
};

// Banners
export const getBanners = async () => {
  try {
    const bannersCol = collection(db, 'banners');
    const q = query(bannersCol, orderBy('order', 'asc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Error getting banners:', error);
    return [];
  }
};

export const addBanner = async (bannerData) => {
  try {
    const bannersCol = collection(db, 'banners');
    const docRef = await addDoc(bannersCol, bannerData);
    return { id: docRef.id, ...bannerData };
  } catch (error) {
    console.error('Error adding banner:', error);
    throw error;
  }
};

export const updateBanner = async (id, bannerData) => {
  try {
    const bannerDoc = doc(db, 'banners', id);
    await updateDoc(bannerDoc, bannerData);
    return { id, ...bannerData };
  } catch (error) {
    console.error('Error updating banner:', error);
    throw error;
  }
};

export const deleteBanner = async (id) => {
  try {
    const bannerDoc = doc(db, 'banners', id);
    await deleteDoc(bannerDoc);
  } catch (error) {
    console.error('Error deleting banner:', error);
    throw error;
  }
};
